"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchMediaAssets = batchMediaAssets;
exports.batchTrials = batchTrials;
exports.getLeftoverAssets = getLeftoverAssets;
const camelize_1 = require("./camelize");
const combineMediaAssets_1 = require("./combineMediaAssets");
const filterMedia_1 = require("./filterMedia");
function batchMediaAssets(mediaAssets, batchList, imageFields, // fields of corpus where image assets are specified (varies by task)
audioFields = ['audioFile']) {
    // organize media assets by block
    const batchedMediaAssets = [];
    // list names of all assets found in particular block of corpus
    const batchedAssetNames = {
        audio: [],
        images: [],
    };
    // get all media assets from each block into mediaAssetsPerBlock
    batchList.forEach((currBatchTrials) => {
        let blockAudio = [];
        currBatchTrials.forEach((trial) => {
            audioFields.forEach((string) => {
                const trialField = trial[string];
                if (trialField !== undefined && trialField.length !== 0) {
                    if (typeof trialField === 'string') {
                        blockAudio.push((0, camelize_1.camelize)(trialField));
                    }
                    else {
                        const trialFieldCamelized = trialField.map((key) => (0, camelize_1.camelize)(key));
                        blockAudio.push(...trialFieldCamelized);
                    }
                }
            });
        });
        let blockImages = [];
        currBatchTrials.forEach((trial) => {
            imageFields.forEach((string) => {
                const trialField = trial[string];
                if (trialField !== undefined && trialField.length !== 0) {
                    if (typeof trialField === 'string') {
                        blockImages.push((0, camelize_1.camelize)(trialField));
                    }
                    else {
                        const trialFieldCamelized = trialField.map((key) => (0, camelize_1.camelize)(key));
                        blockImages.push(...trialFieldCamelized);
                    }
                }
            });
        });
        // remove duplicate images from current block
        blockImages = [...new Set(blockImages)];
        // remove duplicate assets already required in other blocks
        blockImages = blockImages.filter((asset) => {
            return !batchedAssetNames.images.includes(asset);
        });
        blockAudio = blockAudio.filter((asset) => {
            return !batchedAssetNames.audio.includes(asset);
        });
        batchedAssetNames.audio.push(...blockAudio);
        batchedAssetNames.images.push(...blockImages);
        const blockAssets = (0, filterMedia_1.filterMedia)(mediaAssets, blockImages, blockAudio, []);
        batchedMediaAssets.push(blockAssets);
    });
    return batchedMediaAssets;
}
// separates a corpus into batches of a certain size for asset preloading
function batchTrials(corpus, batchSize) {
    const finalBatchList = [];
    let currTrialIndex = 0;
    let currBatchIndex = 0;
    corpus.forEach((trial) => {
        if (currTrialIndex === 0) {
            finalBatchList.push([trial]);
        }
        else {
            finalBatchList[currBatchIndex].push(trial);
        }
        currTrialIndex++;
        if (currTrialIndex >= batchSize) {
            currTrialIndex = 0;
            currBatchIndex++;
        }
    });
    return finalBatchList;
}
// function to gather all media assets that were not specified in the corpus
function getLeftoverAssets(batchedMediaAssets, mediaAssets) {
    const allBatchedMedia = (0, combineMediaAssets_1.combineMediaAssets)(batchedMediaAssets);
    const leftoverImageKeys = Object.keys(mediaAssets.images).filter((key) => {
        return !Object.keys(allBatchedMedia.images).includes(key);
    });
    const leftoverAudioKeys = Object.keys(mediaAssets.audio).filter((key) => {
        return !Object.keys(allBatchedMedia.audio).includes(key);
    });
    const leftoverVideoKeys = Object.keys(mediaAssets.video).filter((key) => {
        return !Object.keys(allBatchedMedia.video).includes(key);
    });
    const leftoverMedia = (0, filterMedia_1.filterMedia)(mediaAssets, leftoverImageKeys, leftoverAudioKeys, leftoverVideoKeys);
    return leftoverMedia;
}
